import React, { useState } from "react";
import TextButton from "../../TextButton";
import { StyledContainer } from "./styles";
import { useProjectStore } from "../../../stores/projectStore";
import { AppEventPublisher, StoryBibleType, StoryBibleAction } from "../../../AppEventPublisher.js";

function SendToDoc({ content, title, className }) {
  const [sending, setSending] = useState(false);

  const project = useProjectStore((state) => state.project);

  return (
    <StyledContainer className="send-to-doc">
      <TextButton
        disabled={sending}
        onClick={async (e) => {
          AppEventPublisher.storyBible.action(StoryBibleType.style, StoryBibleAction.SendStyleToDoc);
          setSending(true);

          const result = await project.createDocument({
            content,
            title,
          });

          window.location.href = `/app/project/${project.id}#doc=${result.document.id}`;
        }}
        src="/assets/send-to-doc.svg"
        className={className}
      >
        {sending ? "Sending..." : "Send to Doc"}
      </TextButton>
    </StyledContainer>
  );
}

export default SendToDoc;
